export const ICON_LIST = {
  'arrow-up': 'ic_arrow-up.svg',
  'arrow-down': 'ic_arrow-down.svg',
  'arrow-counterclockwise': 'ic_arrow-counterclockwise.svg',
  'arrow-diagonal-up-right': 'ic_arrow-diagonal-up-right.svg',
  pause: 'ic_stop.svg',
  'chevron-right': 'ic_chevron-right.svg',
  'chevron-left': 'ic_chevron-left.svg',
  'chevron-down': 'ic_chevron-down.svg',
  'chevron-up': 'ic_chevron-up.svg',
  'chevron-right-double': 'ic_chevron-right-double.svg',
  'chevron-left-double': 'ic_chevron-left-double.svg',
  close: 'ic_x.svg',
  menu: 'ic_menu.svg',
  minus: 'ic_minus.svg',
  'check-solo': 'ic_check-solo.svg',
  'check-filled': 'ic_checkbox-filled.svg',
  'check-outlined': 'ic_checkbox-outlined.svg',
  eye: 'ic_eye.svg',
  'eye-slash': 'ic_eye-slash.svg',
  person: 'ic_person.svg',
  plus: 'ic_plus.svg',
  ellipsis: 'ic_ellipsis.svg',
  gear: 'ic_gear.svg',
  calendar: 'ic_calendar.svg',
  magnify: 'ic_mag.svg',
  question: 'ic_question-mark.svg',
  exclamation: 'ic_exclamation-mark.svg',
  download: 'ic_download.svg',
  instagram: 'ic_instagram.svg',
  'naver-blog': 'ic_naver-blog.svg',
  youtube: 'ic_youtube.svg'
};
